///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance = abcsetup.front_store.maintenance || {};
abcsetup.front_store.maintenance.show = abcsetup.front_store.maintenance.show || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.maintenance.show = {
    init: function() {
        abcsetup.setTitle('View Consumer Item');

        // Set the global item var
        abcsetup.item = JSON.parse($('form.front-store-item #item_object').html());
        abcsetup.form_manager.form = $('form.front-store-item');
        abcsetup.form_manager.setFormItems(true);
    },

    /**
     * _jquery.fieldLib hase been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all front store form related JS is handled in the global /forms/_front_store_item.js form namespace
        abcsetup.front_store.form.init(true);
    },
}
